import { default as MuiInputLabel, InputLabelProps } from '@mui/material/InputLabel'

import { styled } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { MsdkStyledComponent } from '../../utils'

type MsdkFormFieldLabel = InputLabelProps & { filterField?: boolean; hasEndAdornment?: boolean }

const MuiFormFieldLabel: MsdkStyledComponent<MsdkFormFieldLabel> = styled(MuiInputLabel, {
  shouldForwardProp: (prop) => prop !== 'filterField' && prop !== 'hasEndAdornment',
})<{
  filterField?: boolean
  hasEndAdornment?: boolean
}>`
  &.Mui-focused,
  &.MuiFormLabel-filled {
    padding-right: ${({ filterField }) => {
      if (!filterField) return '24px;'
      return '0;'
    }};
  }

  color: ${COLORS.text.secondary};
  padding: 0;
  padding-right: ${({ filterField, hasEndAdornment }) => {
    if (!filterField && !hasEndAdornment) return '16px;'
    if (filterField && hasEndAdornment) return '16px;'
    if (hasEndAdornment) return '32px;'
    return '0;'
  }};
`

export const FormFieldLabel = createComponentWrapperWithRef<MsdkFormFieldLabel>(
  {
    mui: MuiFormFieldLabel,
    nova: MuiFormFieldLabel,
  },
  'FormFieldLabel',
)
